import {AutoRegItemType} from "@/main/autoreg/accounts/store/type/autoRegItem.type";

export function GetColumnsNameTableUtil(data: AutoRegItemType[]): string[] {
  let result: string[] = [];
  if(data && data.length !== 0) {
    result = Object.keys(data[0])
  }
  return result;
}
